import React from 'react';

import * as S from './styles';

type Props = {
  to?: string | null;
  isExternal?: boolean;
  className?: string;
  children?: React.ReactNode;
  onClick?: (e: React.MouseEvent) => void;
  disabled?: boolean;
} & Pick<React.ComponentProps<'a'>, 'rel' | 'target'>;

const Clickable = ({ to, isExternal, disabled, ...props }: Props) => {
  if (!to) {
    return <S.Button disabled={disabled} {...props} />;
  }

  return isExternal || disabled ? (
    <S.ExternalLink href={disabled ? undefined : to} {...props} />
  ) : (
    <S.InternalLink
      to={to}
      {...props}
      data-test={props['data-test'] || 'InternalLink'}
    />
  );
};

export default Clickable;
